import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Gamepad = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M12.836 12.16a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM11.502 13.494a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z" />
      <path d="M4.002 8.494h8a3.667 3.667 0 1 1-3.263 5.333H7.265a3.667 3.667 0 1 1-3.263-5.333Zm8 6.667a3 3 0 1 0 0-6h-8a3 3 0 1 0 2.747 4.2.333.333 0 0 1 .305-.2H8.95a.334.334 0 0 1 .305.2 3 3 0 0 0 2.747 1.8Z" />
      <path d="M4.001 13.827a.333.333 0 0 1-.333-.333v-2.666a.333.333 0 1 1 .667 0v2.666a.333.333 0 0 1-.334.333Z" />
      <path d="M5.336 12.493H2.669a.333.333 0 1 1 0-.667h2.667a.333.333 0 1 1 0 .667ZM8.001 7.16a.333.333 0 0 1-.333-.333v-4a.333.333 0 0 1 .667 0v4A.333.333 0 0 1 8 7.161Z" />
    </svg>
  );
};

Gamepad.category = 'product-category';

Gamepad.displayName = 'Gamepad';
